import React, { Component } from "react";
import Desplegable from "../../desplegable";
import VistaDatosSTJ from "../vistas/vista_datos_STJ";
import FormDatosSTJ from "../formularios/form_datos_STJ";

export default class DesplegableDatosSTJ extends Component {
  render() {
    return (
      <Desplegable
        eventKey="12"
        id="12"
        handleButtonShow={this.props.handleButtonShow}
        showModal={this.props.state.showModalMatrix[12]}
        Toogle={"Datos STJ"}
        Text={<VistaDatosSTJ DatosMonja={this.props.state.DatosUsuario}/>}
        Form={
          <FormDatosSTJ
            DatosMonja={this.props.state.DatosUsuario}
            setDatosHermana={this.props.setDatosHermana}
            handleButtonShow={this.props.handleButtonShow}
            setAlert={this.props.setAlert}
            ErrorHandling={this.props.ErrorHandling}
          />
        }
        canEdit={this.props.esAdmin}
      />
    );
  }
}
